import Modal from "..";
import {useNavigate} from "react-router-dom";
import Typo from "../../typo";
import Button from "../../button";
import {useCancelMissionRunner} from "../../../../feature/mission/api/missionRunner";
import handleError from "../../../helper/handelError";

const CancelMissionRunnerModal = ({isOpen, onClose, isCourse,missionRunnerId}) => {
    const {
        mutate: cancelMissionRunner
    } = useCancelMissionRunner();

    const navigate = useNavigate();

    const handleOnClick = () => {
        cancelMissionRunner({missionRunnerId: missionRunnerId}, {
            onSuccess: (data) => {
                navigate('/')
            }, onError: (error) => {
                handleError(error)
            }
        })
    };
    return (
        <Modal isOpen={isOpen} title={' انصراف از ' +  (isCourse ? "دوره" : "ماموریت")} className="flex flex-col gap-2" onClose={onClose}>
            <Typo className="text-center">آیا مطمئن هستید؟</Typo>
            <div className={'flex gap-4'}>
                <Button type={'light'} onClick={onClose}>بازگشت</Button>
                <Button type={'danger'} onClick={handleOnClick}>{' انصراف از ' +  (isCourse ? "دوره" : "ماموریت")}</Button>
            </div>
        </Modal>
    );
};

export default CancelMissionRunnerModal;
